import Pikaday from 'pikaday';
import Choices from 'choices.js';

import renderPostalCodePreselect from './PostalCodePreselect/index.jsx';

const find = (selector, element = document) => [].slice.call(element.querySelectorAll(selector));
const findOne = (selector, element = document) => element.querySelector(selector);

const fireChange = element => {
	if ('createEvent' in document) {
		const evt = document.createEvent('HTMLEvents');
		evt.initEvent('change', false, true);
		element.dispatchEvent(evt);
	} else {
		element.fireEvent('onchange');
	}
};

const isIE11 = () => navigator.userAgent.match(/Trident.*rv:11\./);

const pikadayDefaultConfig = {
	firstDay: 1,
	i18n: {
		previousMonth: '',
		nextMonth: '',
		months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
			'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
		weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		weekdaysShort: ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'],
	},
};

const handleMultiRequired = el => {
	const multiInput = findOne('.formField__multiInput--required', el);


	if (multiInput) {
		const checkBoxes = find('input[type="checkbox"]', multiInput);

		const handleChange = () => {

			if (checkBoxes.some(checkbox => checkbox.checked)) {
				checkBoxes.forEach(checkbox => checkbox.removeAttribute('required'));
			} else {
				checkBoxes.forEach(checkbox => checkbox.setAttribute('required', 'required'));
			}
			checkBoxes[0].parentNode.parentNode.parentNode.parentNode.classList.add('dummy');
			setTimeout(() => checkBoxes[0].parentNode.parentNode.parentNode.parentNode.classList.remove('dummy'), 0);
		};

		checkBoxes.forEach(checkbox => {
			checkbox.addEventListener('change', handleChange);
		});

		handleChange();
	}
};

// scroll to first error element (if any)
const scrollToError = el => {
	const errorElements = document.getElementsByClassName("formField--isError");
	if(errorElements[0]) {
		const rect = errorElements[0].getBoundingClientRect();
		if(rect.top) {
			window.scrollTo({'behavior': 'smooth', 'left': 0, 'top': rect.top})
		}
	}
};

const db64_to_utf8 = str => {
	try {
		return document.getElementById(str) ? '' : decodeURIComponent(escape(window.atob(str)));
	} catch (e) {}

	return '';
}

// takes german date string and makes it a js date object (dd.mm.yyyy)
const getDate = (dateString) => ((dateString != '') ? new Date(dateString.split('.').reverse().join('-')) : '')

const preValues =
	(typeof window.location.hash != 'undefined' && window.location.hash !== '')
	&& db64_to_utf8(window.location.hash.substr(1))
		.split(',')
		.reduce((obj, item) => {
			const keyValue = item.trim().split('=');
			obj[keyValue[0]] = keyValue[1];
			return obj;
		}, {})
	|| {};


/* UPDATED CODE FROM HERE */
const getFormSchoolInputs = () => {
	const $inputs = {
		$name: findOne('[name*="school_company"]'),
		$streetName: findOne('[name*="school_street"]'),
		$streetNumber: findOne('[name*="school_house_number"]'),
		$postalCode: findOne('[name*="school_zip"]'),
		$addressLocality: findOne('[name*="school_city"]')
	};

	if (Object.keys($inputs).some(key => !Boolean($inputs[key]))) {
		console.error('Missing at least one required form-input:', $inputs);
		return {};
	}

	return $inputs;
};

const renderPostalCodeApplication = ($el) => {
	const $inputsToServe = getFormSchoolInputs();

	// Check, if all required inputs exist.
	if (!Object.keys($inputsToServe).length) {
		return;
	}

	// This is sooo bad, but form-builder markup will enforce it.
	const followingSiblings = [];
	let node = $el.parentNode;
	while (node.nextSibling) {
		node = node.nextSibling;
		followingSiblings.push(node);
	}

	const $appNode = document.createElement('div');
	$el.parentNode.parentNode.replaceChild($appNode, $el.parentNode);

	// API to communicate with exisiting DOM-nodes.
	const toggleInputs = (show = true) =>
		followingSiblings.forEach(node => show ?
			node.classList.remove('sibling_is_hidden') :
			node.classList.add('sibling_is_hidden')
		);

	const selectSchool = (school = {}, preSelectedPostalCode = '') => {
		const {identifier = '', name = '', streetAddress = '', postalCode = '', addressLocality = ''} = school;
		const {$name, $streetName, $streetNumber, $postalCode, $addressLocality} = $inputsToServe;
		let streetName = '';
		let streetNumber = '';

		try {
			streetName = streetAddress.match(/^[^\d]*/)[0];
			streetNumber = streetAddress.match(/\d.*/)[0];
		} catch(e) {}

		$name.value = [name, Boolean(name.length) && `(CTS-ID: ${identifier})`].filter(i => i).join(' ') || '';
		$streetName.value = streetName || '';
		$streetNumber.value = streetNumber || '';
		$postalCode.value = postalCode || preSelectedPostalCode;
		$addressLocality.value = addressLocality;

		if (!identifier && $postalCode.value.length) {
			$postalCode.parentNode.classList.add('formField--filled');
		} else {
			$postalCode.parentNode.classList.remove('formField--filled');
		}
	};

	renderPostalCodePreselect($appNode, {
		onSchoolSelect: selectSchool,
		onToggleManualInput: toggleInputs
	});

	// Hide SchoolForm, except in BE.
	if (!document.body.classList.contains('neos-backend')) {
		toggleInputs(false);
	}
};

export default el => {

	handleMultiRequired(el);
	scrollToError(el);

	const input = findOne('.textInput, select, textarea', el);

	if (input) {
		const clearButton = findOne('.formField__clearInput', el);

		const onBlur = () => {
			if (input.value !== '') {
				el.classList.add('formField--filled');
			} else {
				el.classList.remove('formField--filled');
				el.classList.remove('formField--active');
			}
		};

		input.addEventListener('blur', onBlur);

		input.addEventListener('focus', () => {
			el.classList.add('formField--active');
		});

		clearButton.addEventListener('click', () => {
			input.value = '';

			el.classList.remove('formField--filled');
			fireChange(input);
		});

		onBlur();

		if (input.dataset.component === 'DatePicker') {
			const componentConfiguration = JSON.parse(input.getAttribute('data-component-configuration')) || {};
			const minDate = componentConfiguration.minDate && getDate(componentConfiguration.minDate);
			const beforeField = componentConfiguration.beforeField;
			const picker = new Pikaday({
				...pikadayDefaultConfig,
				...componentConfiguration,
				field: input,
				format: 'DD.MM.YYYY',
			});
			if (minDate) {
				picker.setMinDate(minDate);
			}
			if (beforeField) {
				const field = findOne(`[name="${beforeField}"]`);
				field.addEventListener('change', () => {
					const date = (field.value && getDate(field.value)) || minDate;
					picker.setMinDate(date);
					if (!input.value) {
						picker.gotoDate(date);
					}
					if (input.value && date > getDate(input.value)) {
						picker.setDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()+1));
					}
				});
			}
		}

		if (input.dataset.component === 'DurationAutofill') {
			const componentConfiguration = JSON.parse(input.getAttribute('data-component-configuration'));
			const arrivalField = findOne(`[name="${componentConfiguration.arrivalFieldName}"]`);
			const departureField = findOne(`[name="${componentConfiguration.departureFieldName}"]`);
			[arrivalField, departureField].forEach(field => {
				field.addEventListener('change', () => {
					if (arrivalField.value.match(/\d{2}.\d{2}.\d{4}/) && departureField.value.match(/\d{2}.\d{2}.\d{4}/)) {
						const arrDate = getDate(arrivalField.value);
						const depDate = getDate(departureField.value);
						input.value = Math.round(Math.abs((arrDate.getTime() - depDate.getTime())/(24*60*60*1000))) + 1;
						fireChange(input);
						el.classList.add('formField--filled');
					}
				});
			});
		}

		if (input.getAttribute('data-component') === 'MultiSelect') {
			let disabled = Boolean(input.disabled);
			if (disabled) {
				input.disabled = null;
			}
			const choices = new Choices(input, {
				removeItemButton: true,
				searchEnabled: false,
				shouldSort: false,
				noChoicesText: 'Keine weiteren Optionen vorhanden.',
				itemSelectText: 'Zum Hinzufügen anklicken.',
				callbackOnInit: function() {
					if (disabled) {
						setTimeout(() => {
							input.disabled = 'disabled';
						}, 200);
					}
				}
			});

			const name = /\[(.*?)]\[]/.exec(input.name);
			let preValuesName = '';

			if (name[1] === 'reiseland') {
				preValuesName = 'destination';
			}
			if (name && name[1] && preValues[preValuesName]) {
				choices.setValueByChoice([preValues[preValuesName]]);
				fireChange(input);
			}

			if (preValues.trip) {
				const preSelectedChoice = choices.presetChoices.find(({value}) => {
					return preValues.trip.replace('–', '-').indexOf(value) === 0;
				});
				if (preSelectedChoice) {
					choices.setValueByChoice(preSelectedChoice.value);
					fireChange(input);
				}

			}

			/* This handles a bug in IE11 with options changed in a required multiselect.
			* Choices.js updates selected options, by adding only selected options to corresponding (hidden) native select.
			* So on validity check select will always fail, even if there are selected options.
			*/
			if (isIE11()) {
				// This identifier will be handled  in './PreventMultisubmit.js'.
				input.setAttribute('data-handle-before-submit', '');
			}

			if (input.required) {
				input.style.display = 'block';
				input.style.opacity = 0;
				input.style.position = 'absolute';
				input.style.pointerEvents = 'none';


				choices.containerOuter.classList.add('choices--required');

				const handleItemChange = () => {

					// Remove required-prop at IE11 to pass clientside validity check.
					if (isIE11()) {
						if (input.value.length) {
							input.removeAttribute('required');
						} else {
							input.setAttribute('required', 'required');
						}
					}

					if (choices.getValue().length > 0) {
						choices.containerOuter.classList.remove('choices--required');
						el.classList.add('formField--filled');
					} else {
						choices.containerOuter.classList.add('choices--required');
						el.classList.remove('formField--filled');
					}
				};

				const handleShowDropdown = () => {
					document.body.style.cursor = 'pointer';
				};

				const handleHideDropdown = () => {
					document.body.style.cursor = 'default';
				};

        input.addEventListener('addItem', handleItemChange, false);
        input.addEventListener('removeItem', handleItemChange, false);
        if (document.body.classList.contains('u-isTouchDevice')) {
          input.addEventListener('showDropdown', handleShowDropdown, false);
          input.addEventListener('hideDropdown', handleHideDropdown, false);
        }
        clearButton.addEventListener('click', () => choices.removeActiveItems());
      }
	}

		if (input.dataset.component === 'selectPostalCode') {
			renderPostalCodeApplication(input);
		}
	}
}
